import {
  ActionValidation,
  BooleanValidation,
  StringValidation,
} from '../../../../utils/component-validations';
import CloseButton from '../../action/button/close.gjs';
import FlexColumn from '../../layout/flex/column.gjs';
import FlexRow from '../../layout/flex/row.gjs';
import Super from '../../core/base.gjs';
import Title from './header/title.gjs';
import styles from './header.module.scss';

export default class SpdsModalStandardHeader extends Super {
  arguments = [
    new ActionValidation({ required: ['close'] }),
    new StringValidation({ optional: ['title'] }),
  ];
  baseClass = 'spds-modal-standard-header';
  componentName = 'Spds::Modal::Standard::Header';
  styles = styles;

  get closeBtnId() {
    return this.composeSubcomponentId('close-btn');
  }

  get titleColumn() {
    return this.args.titleColumn ?? false;
  }

  get titleComponent() {
    return this.titleColumn ? FlexColumn : FlexRow;
  }

  get titleId() {
    return this.composeSubcomponentId('title');
  }

  constructor() {
    super(...arguments);

    if (this.args.title) {
      this.arguments.push(new BooleanValidation({ forbidden: ['titleColumn'] }));
    } else {
      this.arguments.push(new BooleanValidation({ optional: ['titleColumn'] }));
    }
  }

  get alignItems() {
    return this.args.alignItems ?? 'center';
  }

  get justifyContent() {
    return this.args.justifyContent ?? 'space-between';
  }

  <template>
    <FlexRow
      @alignItems={{this.alignItems}}
      @justifyContent={{this.justifyContent}}
      @tag="header"
      class={{this.classes}}
      data-test-spds-modal-standard-header
      id={{this.id}}
      {{this.validateArguments}}
      ...attributes
    >
      {{#if @title}}
        <Title @title={{@title}} id={{this.titleId}} />
      {{else}}
        <this.titleComponent
          class="spds-modal-standard-header-title"
          data-test-spds-modal-standard-header-title
          id={{this.titleId}}
        >
          {{yield}}
        </this.titleComponent>
      {{/if}}
      <CloseButton
        @close={{@close}}
        data-test-spds-modal-standard-header-close-button
        id={{this.closeBtnId}}
      />
    </FlexRow>
  </template>
}
